import React, { useEffect, useState } from 'react'
import { Input } from '@fluentui/react-components'
import { t } from '../../../i18n/i18n'
import { Control, Controller } from 'react-hook-form'
import './resetInput.css'
import { Field } from './Field'

type ControlledCfarInputProps = {
   name: any
   control: Control<any>
   defaultValue?: number
   label?: string
   disabled?: boolean
   required?: boolean
}
export const ControlledCfarInput = ({ name, control, label, disabled, required, defaultValue }: ControlledCfarInputProps) => {
   const formatCfar = (value: string) => {
      const cleanedValue = value.replace(/\D/g, '')
      if (cleanedValue.length <= 5) {
         return cleanedValue
      }
      return `${cleanedValue.slice(0, 6)}-${cleanedValue.slice(6, 8)}`
   }

   const [shownValue, setShownValue] = useState(formatCfar(defaultValue?.toString() ?? ''))
   useEffect(() => {
      setShownValue(formatCfar(defaultValue?.toString() ?? ''))
   }, [defaultValue])
   return (
      <Controller
         name={name}
         control={control}
         rules={{
            required: required ? t('RequiredField') : false,
            pattern: {
               value: /^[0-9]+$/,
               message: t('InvalidCfar'),
            },
            minLength: {
               value: 8,
               message: t('CfarLengthMessage'),
            },
            maxLength: {
               value: 8,
               message: t('CfarLengthMessage'),
            },
         }}
         render={({ field: { value, onChange }, fieldState: { error }, formState: { disabled: formDisabled } }) => {
            return (
               <Field label={label} required={required ?? false} validationMessage={error ? error.message : null} validationState={error ? 'error' : null}>
                  <Input
                     type="text"
                     value={shownValue}
                     onChange={(e, data) => {
                        const rawValue = data.value.replace(/\D/g, '')?.slice(0, 8)
                        if (rawValue === '') onChange(null)
                        else onChange(rawValue)
                        setShownValue(rawValue)
                     }}
                     disabled={(disabled || formDisabled) ?? false}
                     onBlur={() => {
                        const formatted = formatCfar(value ?? '')
                        setShownValue(formatted)
                     }}
                  />
               </Field>
            )
         }}
      />
   )
}
